import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class QuantityPickerInteractionApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.QuantityPickerInteraction;

  constructor(
    private label: string
  ) {
  }

  getPayload(): any {
    return {
      label: this.label
    };
  }
}
